






























































































































import { computed, defineComponent, ref, toRefs, watch } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import { MaterialSource, PostUploadRules } from '@tt4b/ttam-enums';

import TtamLearnMore from 'src/components/common/learn-more/index.vue';
import TtamIconButton from '../components/icon-button.vue';

const name = 'ttam-material-select-buttons';

// 推视频选项对应视频来源
const PUSH_VIDEO_SOURCE_MAP = {
  [MaterialSource.NativeLibrary]: 'native_library',
  [MaterialSource.Upload]: 'upload',
  [MaterialSource.Library]: 'material_library',
  [MaterialSource.CreativeTool]: 'create',
};

function generateSingleVideoTeaParams(type) {
  const clickKey = 'create_ad_creative_video';
  const showKey = 'create_ad_creative_video_expose';

  return {
    'data-tea-creative-type': 'video',
    'data-tea': clickKey,
    'data-tea-expose': showKey,
    'data-tea-click-entre': type,
  };
}

function generateSingleImageTeaParams(type) {
  // capture from video 的埋点参数和其他不太一样，这里区分一下
  if (type === MaterialSource.CaptureVideo) {
    return {
      'data-tea-expose': 'create_ad_creative_capture_image_show',
    };
  } else {
    const clickKey = 'create_ad_creative_image';
    const showKey = 'create_ad_creative_image_expose';
    return {
      'data-tea-creative-type': 'image',
      'data-tea': clickKey,
      'data-tea-expose': showKey,
      'data-tea-click-entre': type,
    };
  }
}

export default defineComponent({
  name,

  components: {
    TtamLearnMore,
    TtamIconButton,
  },

  props: {
    isNative: { type: Boolean, default: false },
    isSingleImage: { type: Boolean, default: false },
    isSelectedMaterial: { type: Boolean, default: false },
    isSupportChangeCover: { type: Boolean, default: false },
    isSupportUsePullVideo: { type: Boolean, default: true },
    isSupportUseTTBAPushVideo: { type: Boolean, default: false },
    isSupportUseTTBCPushVideo: { type: Boolean, default: false },
    isPushVideoButtonDisabled: { type: Boolean, default: false },
    isSingleVideo: { type: Boolean, default: true },
    size: { type: String, default: 'normal' },
    isTiktokPostBtnDisabled: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const {
      isNative,
      isSingleImage,
      isSelectedMaterial,
      isSupportChangeCover,
      isSupportUsePullVideo,
      isSupportUseTTBAPushVideo,
      isPushVideoButtonDisabled,
      isSingleVideo,
      isTiktokPostBtnDisabled,
      isSupportUseTTBCPushVideo,
    } = toRefs(props);
    const isPushVideoSupportButDisabled = computed(
      () => (isSupportUseTTBCPushVideo.value || isSupportUseTTBAPushVideo.value) && isPushVideoButtonDisabled.value,
    );

    /** 按钮类型 */
    const buttonType = computed(() => (isSelectedMaterial.value ? 'text' : 'button'));

    /** native buttons */
    const nativeButtons = computed(() => {
      const children = [];

      const clickKey = isSelectedMaterial.value ? 'creative_spark_ads_update_video' : 'creative_spark_ads_add_video';

      if (isSelectedMaterial.value && isSupportUsePullVideo.value) {
        children.push({
          isTitle: true,
          title: i18n.t('module_ttba_change_video_use_existing_post_label'),
        });
        children.push({
          type: MaterialSource.NativeLibrary,
          label: i18n.t('module_ttba_change_video_use_existing_post'),
        });
      }
      /** 推视频 */
      if (
        (isSupportUseTTBAPushVideo.value || isSupportUseTTBCPushVideo.value) &&
        !(isPushVideoButtonDisabled.value && isSelectedMaterial.value)
      ) {
        /** 推视频标题 */
        if (isSelectedMaterial.value) {
          children.push({
            isTitle: true,
            title: i18n.t('module_ttba_change_video_use_video_label'),
          });
        }
        children.push({
          type: MaterialSource.Upload,
          label: i18n.t('common_upload'),
          hover: { tips: PostUploadRules(), link: 'VIEW_VIDEO_GUIDANCE' },
          // trackProps: generateSingleVideoTeaParams('computer'),
        });
        children.push({
          type: MaterialSource.Library,
          label: i18n.t('ad_add_from_library'),
          // trackProps: generateSingleVideoTeaParams('library'),
        });
        children.push({
          type: MaterialSource.CreativeTool,
          label: i18n.t('common_create'),
          // trackProps: generateSingleVideoTeaParams('create_tools'),
        });
      }

      const buttons = [];
      if (!isSelectedMaterial.value && isSupportUsePullVideo.value) {
        buttons.push({
          type: MaterialSource.NativeLibrary,
          label: i18n.t('module_ttba_use_tt_post_btn_text'),
          trackProps: {
            ...generateSingleVideoTeaParams('library'),
            'data-tea-is-spark-ads': 'true',
          },
          disabled: isTiktokPostBtnDisabled.value,
        });
      }
      if (children.length) {
        buttons.push({
          label: isSelectedMaterial.value ? i18n.t('common_update') : i18n.t('common_video'),
          icon: isSelectedMaterial.value ? 'vi-icon2-edit' : 'vi-icon2-add-small',
          canMergeChildren: !isPushVideoSupportButDisabled.value,
          children: children.map(o => ({
            ...o,
            trackProps: {
              'data-tea-video_source': PUSH_VIDEO_SOURCE_MAP[o.type],
              'data-tea': clickKey,
            },
          })),
          ...(isPushVideoSupportButDisabled.value
            ? {
                disabled: !isSelectedMaterial.value,
                disableTip: true,
              }
            : {}),
        });
      }
      return buttons;
    });

    /** single video buttons */
    const singleVideoButtons = computed(() => {
      const arr = [
        {
          type: MaterialSource.Upload,
          label: i18n.t('library_image_upload'),
          trackProps: generateSingleVideoTeaParams('computer'),
        },
        {
          type: MaterialSource.Library,
          label: i18n.t('module_ad_upload_operation_library'),
          trackProps: generateSingleVideoTeaParams('library'),
        },
        {
          type: MaterialSource.CreativeTool,
          label: i18n.t('module_ad_upload_operation_create'),
          trackProps: generateSingleVideoTeaParams('create_tools'),
        },
      ];
      if (isSelectedMaterial.value) {
        let label = i18n.t('common_video');
        if (isSelectedMaterial.value) {
          label = i18n.t('common_update');
        }
        return [
          {
            icon: isSelectedMaterial.value ? 'vi-icon2-edit' : 'vi-icon2-add-small',
            label,
            children: arr,
          },
        ];
      }
      return arr;
    });

    /** singe image buttons */
    const singleImageButtons = computed(() => {
      const arr = [
        {
          type: MaterialSource.Upload,
          label: i18n.t('module_ad_upload_operation_upload'),
          trackProps: generateSingleImageTeaParams('computer'),
        },
        {
          type: MaterialSource.Library,
          label: i18n.t('module_ad_upload_operation_library'),
          trackProps: generateSingleImageTeaParams('library'),
        },
        // {
        //   type: MaterialSource.CaptureVideo,
        //   label: i18n.t('module_capture_image_from_video_btn_text'),
        //   tips: i18n.t('module_capture_image_from_video_explain_text'),
        //   trackProps: generateSingleImageTeaParams('capture_video'),
        // },
      ];
      const menuArr = [
        {
          type: MaterialSource.Upload,
          label: i18n.t('ad_update_from_computer'),
          trackProps: generateSingleImageTeaParams('computer'),
        },
        {
          type: MaterialSource.Library,
          label: i18n.t('ad_add_from_library'),
          trackProps: generateSingleImageTeaParams('library'),
        },
      ];
      if (isSelectedMaterial.value) {
        return [
          {
            icon: 'vi-icon2-edit',
            label: i18n.t('common_update'),
            children: menuArr,
          },
        ];
      }
      return arr;
    });

    /** 处理 buttonConfig，移除不需要的 title、dropdown */
    const handleButtonConfig = (buttonConfig: any[]) => {
      const res = buttonConfig.map(child => {
        let tempChild = child;

        if (!tempChild.canMergeChildren) {
          return tempChild;
        }

        /** 如果只有一个 title 则去掉 */
        if (tempChild.children?.filter(grandson => grandson?.isTitle)?.length === 1) {
          tempChild = {
            ...child,
            children: tempChild.children?.filter(grandson => !grandson?.isTitle),
          };
        }

        /** 如果只有一个子项，则将子项 type 合并到父级 */
        if (tempChild.children?.length === 1) {
          tempChild = {
            ...tempChild,
            ...tempChild.children[0],
            icon: child.icon,
            label: child.label,
            children: undefined,
          };
        }

        return tempChild;
      });

      return res;
    };

    const buttonConfig = computed(() => {
      let buttons = [];
      if (isNative.value) {
        buttons = buttons.concat(nativeButtons.value);
      } else {
        if (isSingleImage.value) {
          buttons = buttons.concat(singleImageButtons.value);
        } else {
          buttons = buttons.concat(singleVideoButtons.value);
        }
      }

      if (isSupportChangeCover.value && isSelectedMaterial.value) {
        buttons.push({
          type: MaterialSource.ChangeCover,
          icon: 'vi-icon-ex-image',
          label: i18n.t('ad_cover'),
        });
      }

      return handleButtonConfig(buttons);
    });

    const onClick = item => item.type && emit('click', item.type);
    const onCommand = command => command && emit('click', command);
    const getIconClass = item => item?.icon ?? 'vi-icon2-add-small';
    const getIsHasChildren = item => Boolean(item?.children?.length);

    return {
      name,

      buttonType,
      nativeButtons,
      singleVideoButtons,
      singleImageButtons,
      buttonConfig,
      onClick,
      onCommand,
      getIconClass,
      getIsHasChildren,
    };
  },
});
